import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Hamburger() {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        function onDocumentClick(e) {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                setOpen(false);
            }
        }

        function onKey(e) {
            if (e.key === "Escape") setOpen(false);
        }

        document.addEventListener("mousedown", onDocumentClick);
        document.addEventListener("keydown", onKey);
        return () => {
            document.removeEventListener("mousedown", onDocumentClick);
            document.removeEventListener("keydown", onKey);
        };
    }, []);

    return (
        <div ref={containerRef} style={{ position: "relative", display: "inline-block" }}>
            <button
                className="bm-btn"
                aria-haspopup="true"
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
                aria-label="Open menu"
            >
                <i className="fa fa-bars" aria-hidden="true"></i>
            </button>

            {open && (
                <div role="menu" className="bm-panel">
                    <h3>Activities</h3>
                    <Link role="menuitem" to="/activities" onClick={() => setOpen(false)}>Activities</Link>
                    <Link role="menuitem" to="/gardening" onClick={() => setOpen(false)}>Gardening</Link>
                    <Link role="menuitem" to="/fishing" onClick={() => setOpen(false)}>Fishing</Link>
                    <Link role="menuitem" to="/racing" onClick={() => setOpen(false)}>Racing</Link>
                    <Link role="menuitem" to="/golfing" onClick={() => setOpen(false)}>Golfing</Link>
                    <Link role="menuitem" to="/doodles" className="bm-last-item" onClick={() => setOpen(false)}>Doodles</Link>
                    <hr />
                    <h3>Cogs</h3>
                    <Link role="menuitem" to="/cogs" onClick={() => setOpen(false)}>Cogs</Link>
                    <Link role="menuitem" to="/sellbots" onClick={() => setOpen(false)}>Sellbots</Link>
                    <Link role="menuitem" to="/cashbots" onClick={() => setOpen(false)}>Cashbots</Link>
                    <Link role="menuitem" to="/lawbots" onClick={() => setOpen(false)}>Lawbots</Link>
                    <Link role="menuitem" to="/bossbots" onClick={() => setOpen(false)}>Bossbots</Link>
                    <Link role="menuitem" to="/taskforce" onClick={() => setOpen(false)}>Sellbot Task Force</Link>
                    <Link role="menuitem" to="/fieldoffices" onClick={() => setOpen(false)}>Sellbot Field Offices</Link>
                    <Link role="menuitem" to="/undernewmanagement" className="bm-last-item" onClick={() => setOpen(false)}>Under New Management</Link>
                    <hr />
                    <Link role="menuitem" to="/invasions" onClick={() => setOpen(false)}>Invasion Tracker</Link>
                    <Link role="menuitem" to="/gags" onClick={() => setOpen(false)}>Gags</Link>
                    <Link role="menuitem" to="/statuseffects" onClick={() => setOpen(false)}>Status Effects</Link>
                    <Link role="menuitem" to="/neighborhoods" onClick={() => setOpen(false)}>Neighborhoods</Link>
                    <Link role="menuitem" to="/toontips" onClick={() => setOpen(false)}>Toon Tips</Link>
                    <Link role="menuitem" to="/about" onClick={() => setOpen(false)}>About</Link>
                    <Link role="menuitem" to="/search" onClick={() => setOpen(false)}>Search</Link>
                </div>
            )
            }
        </div>
    );
}
